import React, { useState, useEffect } from 'react';
// components
import Modal from 'shared/modals/Modal';
import toastr from 'shared/helpers/toastr';
import errorToastr from 'shared/helpers/errorToastr';
import LoadingModal from 'shared/loading/LoadingModal';
import Table from 'shared/tables/Table';
import LoadingSpinner from 'shared/loading/LoadingSpinner';
import DispatchErrorBody from './DispatchErrorBody';
import Toggle from 'shared/buttons/Toggle';
// fetch
import { confirmDrivers, confirmLegacyDrivers, dispatchDrivers, dispatchLegacyDrivers } from 'src/fetch/dispatching';

const UnitAssignmentModal = ({ isOpen, close, orders, selected, modernOrders, date, clearDispatchedOrders }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState(null);

  const [sendToDriver, setSendToDriver] = useState(false);

  const getPairings = () => {
    let pairings = [];
    selected.forEach(x => {
      pairings.push({ proNumber: orders[x].proNumber, driverId: orders[x].driver, sentToDriver: sendToDriver });
    });
    return pairings;
  };

  const confirm = async () => {
    try {
      setLoading(true);
      // create pairings
      const pairings = getPairings();
      let confirmDriversResponse;

      if (modernOrders) {
        confirmDriversResponse = await confirmDrivers(pairings);
      } else {
        confirmDriversResponse = await confirmLegacyDrivers(pairings, date);
      }

      setData(confirmDriversResponse);
      setLoading(false);
    } catch (error) {
      console.log('error', error);
      setApiError('Something went wrong! Refresh to try again.');
      setLoading(false);
    }
  };
  useEffect(() => {
    if (isOpen) {
      confirm();
    }
  }, [isOpen]);

  const handleDispatch = async () => {
    setErrors(null);

    try {
      setIsSubmitting(true);
      const pairings = getPairings();

      if (modernOrders) {
        const modernResponse = await dispatchDrivers(pairings);
        clearDispatchedOrders(modernResponse);
      } else {
        const response = await dispatchLegacyDrivers(pairings, date);

        const ordersNotDispatched = response.ordersNotDispatched;
        const dispatchedOrders = response.dispatchedProNumbers;

        clearDispatchedOrders(dispatchedOrders);

        if (ordersNotDispatched.length) {
          setErrors(ordersNotDispatched);
          setIsSubmitting(false);
          return;
        }
      }

      setIsSubmitting(false);
      close();
      toastr('success', 'Dispatched Drivers Successfully.');
    } catch (error) {
      errorToastr({
        error,
        messagePrefix: 'Dispatching Drivers Failed!'
      });
      setIsSubmitting(false);
    }
  };

  const handleCloseErrors = () => {
    setErrors(null);
    close();
  };

  return (
    <Modal isOpen={isOpen} handleClose={() => close()} containerStyle='large'>
      {loading ? (
        <LoadingSpinner />
      ) : !isSubmitting && errors && errors.length > 0 ? (
        <React.Fragment>
          <div className='modal-header'>
            <h5 className='modal-title' id='driver-truck-assignment-modal'>
              Driver/Truck Assignment
            </h5>
            <button className='button large close' onClick={() => close()} />
          </div>
          <DispatchErrorBody errors={errors} handleClose={() => handleCloseErrors()} />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className='modal-header'>
            <h5 className='modal-title' id='driver-truck-assignment-modal'>
              Driver/Truck Assignment
            </h5>
            <button className='button large close' onClick={() => close()} />
          </div>
          <section className={`driver-truck-assignment-form ${isSubmitting ? 'hide-overflow' : ''}`}>
            <LoadingModal isOpen={isSubmitting} isNested={true} />
            <section className='modal-body' style={{ flexDirection: 'column' }}>
              <div className='formik-row' style={{ flexDirection: 'column' }}>
                <Table
                  className='table--primary-color'
                  data={data}
                  apiError={apiError}
                  isLoading={loading}
                  textAlign='left'
                  columns={[
                    { Header: 'Pro #', accessor: 'proNumber', width: 75, isCentered: true },
                    { Header: 'Customer', accessor: 'customer' },
                    { Header: 'Leg #', accessor: 'legNumber', width: 75, isCentered: true },
                    { Header: 'Delivery Stop Type', accessor: 'deliveryStopType' },
                    { Header: 'Delivery Location', accessor: 'deliveryLocation' },
                    { Header: 'Driver Name', accessor: 'driverName' }
                  ]}
                />
              </div>
            </section>
            <section className='modal-footer toolbar toolbar--xxs'>
              <div className='toolbar--column toolbar--right'>
                {modernOrders && (
                  <div style={{ display: 'inline-block', marginRight: '3rem', marginTop: 0 }}>
                    <Toggle
                      isInHeader
                      label='Send to Driver Immediately '
                      value={sendToDriver}
                      onToggle={() => setSendToDriver(!sendToDriver)}
                      onText='Yes'
                      offText='No'
                    />
                  </div>
                )}
                <button
                  type='button'
                  className='button large secondary text-align--center toolbar--button--margin'
                  disabled={isSubmitting}
                  onClick={handleDispatch}
                >
                  Dispatch
                </button>

                <button
                  id='driver-truck-assignment-cancel'
                  className='button large white text-align--center margin--none--xxs'
                  onClick={() => close()}
                >
                  Cancel
                </button>
              </div>
            </section>
          </section>
        </React.Fragment>
      )}
    </Modal>
  );
};

export default UnitAssignmentModal;
